/** Idempotency key of one interview creation: a retry with the same key never creates a duplicate. */
const generateClientReference = (): string => {
	return globalThis.crypto.randomUUID();
};

export default generateClientReference;
